var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserVesselPosition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 2048,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 2048 2048",
    width: 2048,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_225723280",
    fill: "#4251f5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_225722776",
    d: "m602.527 1220.48-265.851-183.528-80.6764-55.6937h98.0056 1297.43 30.5965v30.5953 302.489 30.5965h-30.5965-620.219c-36.9555 0-56.1615.244488-73.1434.46063-159.615 2.03268-171.434 2.18268-355.542-124.919z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_225722632",
    d: "m887.712 947.866 29.3469-69.8871h542.612l19.565 69.8871h-591.524zm43.3689-103.278 35.8536-85.3808c4.97363-11.8488 10.3701-23.6965 18.9626-34.0666 11.4638-13.8378 26.3303-22.9748 47.5205-22.9748h326.328c18.6165 0 33.3331 7.18701 44.8394 18.6945 11.2158 11.2158 18.4642 26.302 22.839 41.9315l22.898 81.7961h-519.241z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_225723304",
    d: "m1651.43 1132.5c-16.8969 0-30.5965 13.6984-30.5965 30.5965 0 16.8969 13.6996 30.5965 30.5965 30.5965h109.974c16.8969 0 30.5965-13.6996 30.5965-30.5965 0-16.898-13.6996-30.5965-30.5965-30.5965z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2048v2048h-2048z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVesselPosition);
export default __webpack_public_path__ + "static/media/user_vessel_position.947d53c6c6521931b6be12de67f4fde6.svg";
export { ForwardRef as ReactComponent };